import { PRODUCTION_FRONTEND_ORIGIN } from "@/config";
import { logger } from "@/lib/logger";

/**
 * 現在表示中の画面に対応する production URL を組み立てます。
 *
 * stg など production 以外で分析した画面をそのまま顧客に共有できるようにするため、
 * path と query は現在地のまま維持し、origin だけを production に差し替えます。
 * path / query が壊れていて URL を組めない場合は production の origin を返します。
 */
export function buildProductionUrl(pathname: string, search: string): string {
  const normalizedPathname = pathname.startsWith("/")
    ? pathname
    : `/${pathname}`;
  const normalizedSearch =
    !search || search === "?"
      ? ""
      : search.startsWith("?")
        ? search
        : `?${search}`;

  try {
    return new URL(
      `${normalizedPathname}${normalizedSearch}`,
      PRODUCTION_FRONTEND_ORIGIN,
    ).toString();
  } catch (error) {
    logger.error(error, { pathname, search });
    return PRODUCTION_FRONTEND_ORIGIN;
  }
}
